import type { RouteObject } from "react-router-dom";

export const rateCalculatorRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Rate calculator" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page /> };
    },
    children: [
      {
        index: true,
        async lazy() {
          const { RateCalculatorPage } =
            await import("./oms-pricing-tool-page");
          return { Component: RateCalculatorPage };
        },
      },
    ],
  },
];
